import {
    Table,
    Row,
    Col,
    Input,
    Button,
    Modal,
} from "reactstrap"
import '../../components/Common/Common.css';
import { useState } from "react";
import {
    setAdmMemberActivityContactsLog,
} from "../../store/actions";
import { useDispatch, useSelector } from "react-redux";

function ContactsLogModal({
    toggleContactLog,
    isContactLogOpen,
    filterValidation,

}) {

    const dispatch = useDispatch();

    const { contactsLog, contactsLogActive, contactsLogTotalPage, loading } = useSelector(state => ({
        loading: state.admMemberStatistics.loading,
        error: state.admMemberStatistics.error,
        success: state.admMemberStatistics.success,
        noticeStr: state.admMemberStatistics.activityNoticeStr,
        activityList: state.admMemberStatistics.activityList,
        contactsLog: state.admMemberStatistics.contactsLog,
        contactsLogActive: state.admMemberStatistics.contactsLogActive,
        contactsLogTotalPage: state.admMemberStatistics.contactsLogTotalPage,
    }))


    // Search contact log
    const [searchKey, setSearchKey] = useState("");
    const [curPage, setcurPage] = useState(1);
    const [curPageInput, setcurPageInput] = useState(1);

    const viewContactsLogList = (curPage) => {
        setcurPage(curPage);
        setcurPageInput(curPage);

        const startIndex = 10 * (curPage - 1);
        let keyFiltered = contactsLog

        if (searchKey != "") {
            keyFiltered = contactsLog.filter(contact => {
                return contact.emailAddress.toLowerCase().includes(searchKey) ||
                    contact.targetGroupName?.toLowerCase().includes(searchKey) ||
                    contact.regUserName?.toLowerCase().includes(searchKey) ||
                    contact.modUserName?.toLowerCase().includes(searchKey)
            })
        }
        const _contactsLogActive = keyFiltered.slice(startIndex, Math.min(startIndex + 10, keyFiltered.length))
        dispatch(setAdmMemberActivityContactsLog({ contactsLog: contactsLog, contactsLogActive: _contactsLogActive, contactsLogTotalPage: contactsLogTotalPage }));
    }

    const searchContactsLog = (keywordValue) => {
        keywordValue = keywordValue.toLowerCase();
        setSearchKey(keywordValue);
        setcurPage(1);
        setcurPageInput(1);

        const filtered = contactsLog.filter(contact => {
            return contact.emailAddress.toLowerCase().includes(keywordValue) ||
                contact.targetGroupName?.toLowerCase().includes(keywordValue) ||
                contact.regUserName?.toLowerCase().includes(keywordValue) ||
                contact.modUserName?.toLowerCase().includes(keywordValue)
        })

        const _contactsLogActive = filtered.slice(0, Math.min(10, filtered.length))
        dispatch(setAdmMemberActivityContactsLog({ contactsLog: contactsLog, contactsLogActive: _contactsLogActive, contactsLogTotalPage: Math.max(Math.ceil(filtered.length / 10), 1) }));
    }

    return (
        <Modal
            size="xl"
            style={{ maxWidth: "1700px" }}
            isOpen={isContactLogOpen && !loading}
            toggle={() => {
                toggleContactLog(null, null)
            }}
        >
            <div className="modal-body">
                <button
                    onClick={() => {
                        toggleContactLog(null, null)
                    }}
                    type="button"
                    className="close"
                    data-dismiss="modal"
                    aria-label="Close"
                >
                    <span aria-hidden="true">&times;</span>
                </button>

                <div className={""}>
                    <div className="container-fluid">
                        <Row>
                            <Col className="col-12">
                                <div className="page-title-box d-flex align-items-center justify-content-between">
                                    <h4 className="mb-0">
                                        {
                                            filterValidation.values.submitType == "viewAddedContactLog" ? "Added Contacts Log" : "Deleted Contacts Log"
                                        }
                                    </h4>
                                </div>
                            </Col>
                        </Row>
                        <Row>
                            <div className="form-inline float-md-end">
                                <div className="search-box ml-2">
                                    <div className="position-relative">
                                        <Input
                                            type="text"
                                            className="orm-control bg-light border-light rounded"
                                            placeholder="Search..."
                                            onKeyPress={(e) => {
                                                if (e.key === 'Enter') {
                                                    searchContactsLog(e.target.value);
                                                }
                                            }}
                                        />
                                        <i className="mdi mdi-magnify search-icon"></i>
                                    </div>
                                </div>
                            </div>
                        </Row>
                        {
                            isContactLogOpen && !loading ? (
                                <>
                                    <Table className="table mb-0">
                                        <thead>
                                            <tr>
                                                <th>Entity</th>
                                                <th>Email address</th>
                                                <th>Created date time</th>
                                                <th>Created user</th>
                                                <th>
                                                    {
                                                        filterValidation.values.submitType == "viewAddedContactLog" ?
                                                            "Last modified date time"
                                                            : "Deleted date time"
                                                    }
                                                </th>
                                                <th>
                                                    {
                                                        filterValidation.values.submitType == "viewAddedContactLog" ?
                                                            "Last modified user"
                                                            : "Deleted user"
                                                    }
                                                </th>
                                                <th>Status</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {
                                                contactsLogActive 
                                                && Array.isArray(contactsLogActive) 
                                                && contactsLogActive.length > 0
                                                && contactsLogActive?.map((log, index) => {
                                                    return (
                                                        <tr key={index}>
                                                            <td>{log.targetGroupName}</td>
                                                            <td>{log.emailAddress}</td>
                                                            <td>{log.regDate}</td>
                                                            <td>{log.regUserName}</td>
                                                            <td>{log.modDate}</td>
                                                            <td>{log.modUserName}</td>
                                                            <td>{log.currentState}</td>
                                                        </tr>
                                                    )
                                                })
                                            }
                                        </tbody>
                                    </Table>
                                    <div className="d-flex justify-content-end">
                                        <span className="d-flex align-items-center gap-2">
                                            <div className="d-flex gap-1">
                                                <Button
                                                    type="button"
                                                    color="primary"
                                                    onClick={() => { viewContactsLogList(1); }}
                                                    disabled={(curPage == 1)}
                                                >
                                                    {"<<"}
                                                </Button>
                                                <Button
                                                    type="button"
                                                    color="primary"
                                                    onClick={() => { viewContactsLogList(Math.max(curPage - 1, 1)); }}
                                                    disabled={(curPage == 1)}
                                                >
                                                    {"<"}
                                                </Button>
                                            </div>
                                            Page{" "}
                                            <strong>
                                                {curPage} of {contactsLogTotalPage}
                                            </strong>

                                            <Input
                                                type="number"
                                                min={1}
                                                style={{ width: 70 }}
                                                max={contactsLogTotalPage}
                                                name="curPage"
                                                defaultValue={curPage}
                                                value={curPageInput}
                                                onChange={(e) => { setcurPageInput(e.target.value) }}
                                                onKeyPress={(e) => {
                                                    if (e.key === 'Enter') {
                                                        viewContactsLogList(e.target.value);
                                                    }
                                                }}
                                            />
                                            <div className="d-flex gap-1">
                                                <Button
                                                    type="button"
                                                    color="primary"
                                                    onClick={() => { viewContactsLogList(Math.min(curPage + 1, contactsLogTotalPage)); }}
                                                    disabled={(curPage == contactsLogTotalPage)}
                                                >
                                                    {">"}
                                                </Button>
                                                <Button
                                                    type="button"
                                                    color="primary"
                                                    onClick={() => { viewContactsLogList(contactsLogTotalPage); }}
                                                    disabled={(curPage == contactsLogTotalPage)}
                                                >
                                                    {">>"}
                                                </Button>
                                            </div>
                                        </span>
                                    </div>

                                </>

                            ) : <></>
                        }
                    </div>
                </div>
            </div>
        </Modal>
    )

}

export default ContactsLogModal;